import {
  ButtonGroup,
  DialogTitle,
  type DialogTitleProps,
  IconButton,
  type SxProps
} from '@mui/material';
import type { FunctionComponent, MouseEventHandler, ReactNode } from 'react';

import { CloseIcon } from '../../../icons/icons';
import { CenteredOpposingBoxes } from '../../styled-components/layouts/layouts.styled';

export const ClosableDialogTitle: FunctionComponent<
  {
    title: string | ReactNode;
    onClose: MouseEventHandler;
    secondaryButton?: ReactNode;
    closeButtonOverrides?: SxProps;
  } & Omit<DialogTitleProps, 'title'>
> = ({
  title,
  secondaryButton,
  onClose,
  closeButtonOverrides = {},
  ...titleProps
}) => (
  <CenteredOpposingBoxes>
    <DialogTitle
      {...titleProps}
      // Override MUI's default `flex: 0 0 auto` so long titles (e.g. repository
      // paths with no whitespace) shrink and wrap instead of overflowing the modal.
      sx={{ minWidth: 0, flexShrink: 1, overflowWrap: 'anywhere' }}
    >
      {title}
    </DialogTitle>
    <ButtonGroup sx={{ margin: 1, ...closeButtonOverrides }}>
      {secondaryButton}
      {onClose && (
        <IconButton aria-label="Close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      )}
    </ButtonGroup>
  </CenteredOpposingBoxes>
);
